// extracted by mini-css-extract-plugin
export default {"promptStarterContainer":"PromptStarter_promptStarterContainer__LnMY7","icon":"PromptStarter_icon__tQlLb","text":"PromptStarter_text__fPyGm"};